import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { T2TBusinessMappingContainerModel } from '../../../../../models/aggregates/t2t'
import { ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config } from '../shared';

@Injectable({
  providedIn: 'root'
})
export class T2TBusinessMappingService extends BaseApiTemplateService<T2TBusinessMappingContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.T2T_DOMAIN_URL_PREFIX + Core2Config.CONFIG_PREFIX + Core2Config.ERP_PREFIX + 'business-mapping';
    this.httpClient = http;
  }

  createBusinessMapping(mappingContainer: T2TBusinessMappingContainerModel, tenantCode: string,tenantType: string, visa: ApiVisa):
    Observable<ApiResponseModel<T2TBusinessMappingContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/' + tenantCode + '/' + tenantType;
    }
    return this.httpClient.post<ApiResponseModel<T2TBusinessMappingContainerModel>>(
      this.apiUrl,
      mappingContainer,
      this.getHttpHeader(visa)
    );
  }

  updateBusinessMapping(mappingContainer: T2TBusinessMappingContainerModel, tenantCode: string,tenantType: string, visa: ApiVisa):
    Observable<ApiResponseModel<T2TBusinessMappingContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/' + tenantCode + '/' + tenantType;
    }
    return this.httpClient.put<ApiResponseModel<T2TBusinessMappingContainerModel>>(
      this.apiUrl,
      mappingContainer,
      this.getHttpHeader(visa)
    );
  }

  deleteBusinessMapping(guid: string, tenantCode: string,tenantType: string, visa: ApiVisa):
    Observable<ApiResponseModel<T2TBusinessMappingContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/' + tenantCode + '/'+ tenantType+ '/' + guid;
    }
    return this.httpClient.delete<ApiResponseModel<T2TBusinessMappingContainerModel>>(
      this.apiUrl,
      this.getHttpHeader(visa)
    );
  }

}